<script setup lang="ts">
import { AppFlicker, AppButton } from '@libs/ui';

interface ActivityDetailsGalleryLoaderEmits {
  (eventName: 'close'): void;
}

const emit = defineEmits<ActivityDetailsGalleryLoaderEmits>();
</script>

<template>
  <div class="gallery-loader">
    <AppFlicker
      height="100%"
      width="100%"
      border-radius="border-radius-8"
      class="image-loader"
    />
    <div class="floating-buttons">
      <AppButton
        type="secondary"
        state="enabled"
        size="medium"
        :icon="{ name: 'close' }"
        @click="emit('close')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.gallery-loader {
  height: 425px;
  position: relative;

  .image-loader {
    margin-bottom: var(--spacing-16);
  }

  .floating-buttons {
    position: absolute;
    top: var(--spacing-16);
    right: var(--spacing-16);
  }
}
</style>
